import React from 'react';
import { RouteComponentProps, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ApplicationState } from './store';
import AppLayout from './layout/AppLayout';
import { RoutePaths } from './Routes';

interface Props {
  Component: React.FC<RouteComponentProps>;
  path: string;
  exact?: boolean;
}

const AuthRoute = ({ Component, path, exact = false }: Props): JSX.Element => {
  // TODO: DHM: Add a isLoggedIn state
  const isLoggedIn = useSelector(
    (state: ApplicationState) => state.auth.token !== undefined,
  );

  return (
    <Route
      exact={exact}
      path={path}
      render={(props: RouteComponentProps) =>
        isLoggedIn ? (
          <AppLayout>
            <Component {...props} />
          </AppLayout>
        ) : (
          <Redirect
            to={{
              pathname: RoutePaths.Login,
              state: {
                requestedPath: path,
              },
            }}
          />
        )
      }
    />
  );
};

export { AuthRoute };
